import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

export const metabolicHealthFeaturesGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#daa057',
    id: 'lighter-orange-tone',
    position: [90, 10],
    opacity: 1,
    size: 10,
  },
  {
    shape: 'circle',
    hex: '#d59050',
    id: 'orange-tone-1',
    position: [70, 10],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#d59050',
    id: 'orange-tone-2',
    position: [95, 45],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#d59050',
    id: 'orange-tone-3',
    position: [95, 45],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#d59050',
    id: 'orange-tone-4',
    position: [95, 45],
    opacity: 1,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#d2b57f',
    id: 'green-tone-1',
    position: [90, 98],
    opacity: 1,
    size: 50,
  },
  {
    shape: 'ellipse',
    hex: '#E7C687',
    id: 'yellow-tone-1',
    position: [15, 90],
    opacity: 0.8,
    size: 35,
  },
  {
    shape: 'ellipse',
    hex: '#DAA55E',
    id: 'yellow-tone-2',
    position: [15, 10],
    opacity: 0.8,
    size: 35,
  },
];
